import React from "react";
import ReactLoading from "react-loading";
interface LoaderProps {
  colorProp: string;
  height: string | number;
  width: string | number;
}
const Loader: React.FC<LoaderProps> = (props: LoaderProps) => {
  const { colorProp, height, width } = props;
  return (
    <div
      style={{
        display: "flex",
        // height: "100vh",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <ReactLoading
        type={"bubbles"}
        color={colorProp}
        height={height}
        width={width}
      />
    </div>
  );
};

export default Loader;
